module.exports = __webpack_public_path__ + "img/check-attendance-after-event.ef5f7a21.gif";